import { render, staticRenderFns } from "./SelectSortingBucketOverlay.vue?vue&type=template&id=4b962eb9&"
import script from "./SelectSortingBucketOverlay.vue?vue&type=script&lang=js&"
export * from "./SelectSortingBucketOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports